"use client"

import { twMerge } from "tailwind-merge"

import { NotificationListRenderProps } from "@/types/types"
import { generateResponsiveCSS } from "../../../lib/helper"
import { NotificationListContent } from "./components/NotificationListContent"
import { useNotificationList } from "./hooks/useNotificationList"

export const RenderConfig = {
  render: (props: NotificationListRenderProps) => {
    const { title, className, styles, responsiveType, id: componentId } = props

    const { id, posts, loading, finalViewAllLink, locale } = useNotificationList(props, componentId)

    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <div className={twMerge(className)} id={id}>
          <NotificationListContent
            id={id}
            title={title}
            viewAllLink={finalViewAllLink}
            posts={posts}
            loading={loading}
            className={className}
            locale={locale}
          />
        </div>
      </>
    )
  },
}
